import { FC, Fragment } from 'react';
import { Answer, Task } from 'types/elearning';
import { TaskFactory } from '../task-factory';
import { selectCorrectAnswerByTaskId, selectIsTaskChecked } from 'store/topic/topicSlice';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import Paragraph from 'components/universal/paragraph';
import cls from './tasks-generator.module.scss';

interface IProps {
    tasks: Task[];
    isChecked: boolean;
    correctAnswer: Answer['correct_answer'];
    background?: string;
    isQuiz: boolean;
    prefix?: string;
    prescription?: string;
    prescriptionSecond?: string;
}

export const TasksGenerator: FC<IProps> = ({
    tasks,
    isChecked,
    correctAnswer,
    background,
    isQuiz,
    prefix,
    prescription,
    prescriptionSecond
}) => {

    const correctAnswersPerTask = useSelector((state: RootState) =>
        tasks.reduce((acc, task) => {
            acc[task.id] = selectCorrectAnswerByTaskId(task.id)(state);
            return acc;
        }, {} as Record<number, Answer['correct_answer']>)
    );

    const isCheckedPerTask = useSelector((state: RootState) =>
        tasks.reduce((acc, task) => {
            acc[task.id] = selectIsTaskChecked(task.id)(state);
            return acc;
        }, {} as Record<number, boolean>)
    );
    
    return (
        <>{prescription && <Paragraph className={cls.prescription} fontWeight={700}> {prescription}</Paragraph> }
        {prescriptionSecond && <Paragraph className={cls.prescriptionSecond}> {prescriptionSecond}</Paragraph> }
        {tasks?.map?.((task, key) => {
            return (
                <Fragment key={task?.id}>
                    <TaskFactory
                        task={task}
                        isChecked={isQuiz ? isChecked: isCheckedPerTask[task.id]}
                        correctAnswer={isQuiz ? correctAnswer : correctAnswersPerTask[task.id]}
                        background={background}
                        isQuiz={isQuiz}
                        prefix={ !isQuiz ? 
                            (key + 1 && prefix) ? `${prefix} ${key + 1}` : null 
                            : 
                            `${key + 1}`
                        }
                    />
                </Fragment>
            );
        })}
        </>
    );
};
